/* Namea – fast købsknap. Klik indsender den rigtige produktformular, så personaliseringen
   tjekkes som normalt (mangler der noget, scrolles der op til feltet). */
if (!customElements.get('namea-sticky-atc')) {
  customElements.define(
    'namea-sticky-atc',
    class NameaStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.formId = this.dataset.formId;
        this.button = this.querySelector('[data-sticky-button]');
        this.price = this.querySelector('[data-sticky-price]');
        this.button.addEventListener('click', () => this.submit());

        const target = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!target || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(
          ([entry]) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.hidden = !passed;
            document.body.classList.toggle('namea-sticky-visible', passed);
          },
          { threshold: 0 }
        );
        this.observer.observe(target);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(() => this.sync(), 50));
        }
        this.sync();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }

      sync() {
        const priceRoot = document.getElementById(`price-${this.sectionId}`);
        if (priceRoot && this.price) {
          const onSale = priceRoot.querySelector('.price--on-sale');
          const item = onSale
            ? priceRoot.querySelector('.price__sale .price-item--sale')
            : priceRoot.querySelector('.price__regular .price-item--regular');
          if (item && item.textContent.trim()) this.price.textContent = item.textContent.trim();
        }
        const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (main && this.button) {
          const disabled = main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true';
          this.button.disabled = main.hasAttribute('disabled');
          if (disabled && main.textContent.trim()) this.button.textContent = main.textContent.trim();
        }
      }

      submit() {
        const form = document.getElementById(this.formId);
        if (!form) return;
        if (typeof form.requestSubmit === 'function') {
          const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
          form.requestSubmit(main && main.form === form ? main : undefined);
        } else {
          document.getElementById(`ProductSubmitButton-${this.sectionId}`)?.click();
        }
      }
    }
  );
}
